import { render, staticRenderFns } from "./ArchivePatternToolbarMenu.vue?vue&type=template&id=46b316b2&scoped=true"
import script from "./ArchivePatternToolbarMenu.vue?vue&type=script&lang=js"
export * from "./ArchivePatternToolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./ArchivePatternToolbarMenu.vue?vue&type=style&index=0&id=46b316b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b316b2",
  null
  
)

export default component.exports